<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <h2 class="mb-4">Electrochemistry Results - Part B</h2>

      <p class="mb-5">
        Fill in the information in the data table below summarizing your results from Part B of the
        experiment. <b>Please express the percent error value to 3 significant figures.</b>
      </p>

      <v-simple-table>
        <thead>
          <tr>
            <td>
              <stemble-latex content="$\textbf{Variable}$" />
            </td>
            <td style="text-align: center">
              <stemble-latex content="$\textbf{Value}$" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <stemble-latex content="$\text{i) V}_\ce{CuSO4}$" />
              <stemble-latex content="$\text{ in Vol}$" />
              <stemble-latex content="$\text{ Flask 1}$" />
              <stemble-latex content="$\text{ (mL)}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.volCuSO41"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              <stemble-latex content="$\ce{ii) [CuSO4]}$" />
              <stemble-latex content="$\text{ in Vol}$" />
              <stemble-latex content="$\text{ Flask 1}$" />
              <stemble-latex content="$\text{ (M)}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.concFlask1"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              <stemble-latex content="$\text{iii) V}_\ce{CuSO4,dil}$" />
              <stemble-latex content="$\text{ in Vol}$" />
              <stemble-latex content="$\text{ Flask 2}$" />
              <stemble-latex content="$\text{ (mL)}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.volCuSO42"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              <stemble-latex content="$\ce{iv) [CuSO4]}$" />
              <stemble-latex content="$\text{ in Vol}$" />
              <stemble-latex content="$\text{ Flask 2}$" />
              <stemble-latex content="$\text{ (M)}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.concFlask2"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              <stemble-latex content="$\text{v) E}_\text{cell,obs}$" />
              <stemble-latex content="$\text{ (V)}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.EcellObs"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              <stemble-latex content="$\text{vi) E}_\text{cell,theor}$" />
              <stemble-latex content="$\text{ (V)}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.EcellTheoretical"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>

          <tr>
            <td>
              <stemble-latex content="$\text{vii) }\%\,\text{Error}$" />
            </td>
            <td class="centered-input py-2 my-2">
              <calculation-input
                v-model="inputs.pctError"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';

export default {
  name: 'ChemMcMA5ResultsBV3',
  components: {
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        volCuSO41: null,
        concFlask1: null,
        volCuSO42: null,
        concFlask2: null,
        EcellObs: null,
        EcellTheoretical: null,
        pctError: null,
      },
    };
  },
};
</script>
<style scoped></style>
